// src/json/overlayData.json
export const overlaySectionLeakInvestigationAndRemediation = {
    imageUrl: "/assets/imgs/services/10LeakInvestigationAndRemediation/overlaySection/fondo.jpg",
    text: "The best Building Envelope Renewal /",
    highlight: "High-Rise Painting & Restoration services."
};
